import { ApiKey, BaseStation, Device, User } from "@/types/core";
import {
  Subscription,
  HttpEndpoint,
  SnsEndpoint,
  KinesisEndpoint,
  UbidotsEndpoint,
  IotCoreEndpoint,
  AzureEventHubEndpoint
} from "@/types/core-push";

import moment from "moment";

export class CsvUtil {

  public deviceListToCsv(deviceList:Device[]):string {
    let retList:string[] = [];

    retList.push(`deviceId,name,enterpriseId,lastOnline,deviceType,network,loraWanLrrId,internetIp,groupIdList,customMeta,latitude,longitude,locationType,country,state,postcode,locality,fullAddress,numChannels,networkInfo`);

    for(let device of deviceList) {

      let row = [];
      row.push(this.forceString(device.deviceId));
      row.push(this.forceString(device.name ?  device.name : ''));
      row.push(this.forceString(device.enterpriseId));
      row.push(moment(device.lastOnline).toISOString());
      row.push(this.forceString(device.deviceType ? device.deviceType : ''));

      row.push(device.network ? device.network.type : '');
      row.push(this.forceString(device.network && device.network.loraWan && device.network.loraWan.lrrId ? device.network.loraWan.lrrId : ''));
      row.push(this.forceString(device.network && device.network.internet && device.network.internet.ipAddress ? device.network.internet.ipAddress : ''));

      row.push(this.forceString(device.groupIdList.join("\n")));

      row.push(this.forceString(this.customMetaToString(device.customMeta)));
      
      row.push(device.location ? device.location.latitude : '');
      row.push(device.location ? device.location.longitude : '');
      row.push(device.location ? device.location.type : '');
      row.push(this.forceString(device.location && device.location.country ? device.location.country : ''));
      row.push(this.forceString(device.location && device.location.state ? device.location.state : ''));
      row.push(this.forceString(device.location && device.location.postCode ? device.location.postCode : ''));
      row.push(this.forceString(device.location && device.location.locality ? device.location.locality : ''));
      row.push(this.forceString(device.location && device.location.fullAddress ? device.location.fullAddress : ''));

      row.push(device.channelList ? device.channelList.length : '0');

      const networkInfo = JSON.stringify(device.network?.loraWan)?.replace(/"/g, '""');
      row.push(this.forceString(networkInfo));

      retList.push(row.join(','));
    }
    
    return retList.join("\n");
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }

  public customMetaToString(customMeta:Record<string, string|number|boolean|string[]|number[]>):string {
    let retList = [];

    for(let key in customMeta) {
      let value = customMeta[key]
      let valueStr = `${value}`;
      retList.push(`${key}: ${valueStr.replace(/\"/g, '""')}`)
    }

    return retList.join("\n");
  }


  public bssListToCsv(bssList:BaseStation[]):string {

    let retList:string[] = [];

    retList.push(`lrrId,lrrUuid,name,commercialName,enterpriseId,healthState,cnxState,lastUpFrame,lastDwFrame,cnxStateSince,latitude,longitude,cnx0-name,cnx0-type,cnx0-state,cnx0-txAvgRate,cnx0-rxAvgRate,cnx1-name,cnx1-type,cnx1-state,cnx1-txAvgRate,cnx1-rxAvgRate`);

    for(let baseStation of bssList) {

      let row = [];
      row.push(this.forceString(baseStation.lrrId));
      row.push(this.forceString(baseStation.lrrUuid ? baseStation.lrrUuid : ''));
      row.push(this.forceString(baseStation.name));
      row.push(this.forceString(baseStation.commercialName));
      row.push(this.forceString(baseStation.enterpriseId));
      row.push(this.forceString(baseStation.healthState));
      row.push(this.forceString(baseStation.cnxState));

      row.push(moment(baseStation.lastUpFrame).toISOString());
      row.push(moment(baseStation.lastDwFrame).toISOString());
      row.push(moment(baseStation.cnxStateSince).toISOString());

      row.push(baseStation.location && baseStation.location.lat ? baseStation.location.lat : '');
      row.push(baseStation.location && baseStation.location.long ? baseStation.location.long : '');

      for(let i = 0; i < baseStation.connList.length; i++) {

        let cnx = baseStation.connList[i];
        let headRow = retList[0] // where the header is

        if(!headRow.includes(`cnx${i}-name`)) headRow += `cnx${i}-name`;
        if(!headRow.includes(`cnx${i}-type`)) headRow += `cnx${i}-type`;
        if(!headRow.includes(`cnx${i}-state`)) headRow += `cnx${i}-state`;
        if(!headRow.includes(`cnx${i}-txAvgRate`)) headRow += `cnx${i}-txAvgRate`;
        if(!headRow.includes(`cnx${i}-rxAvgRate`)) headRow += `cnx${i}-rxAvgRate`;
        
        row.push(this.forceString(cnx.name))
        row.push(this.forceString(cnx.type))
        row.push(this.forceString(cnx.state))
        row.push(cnx.txAvgRate)
        row.push(cnx.txAvgRate)

      }

      retList.push(row.join(','));
    }
    
    return retList.join("\n");
  }


  public userListToCsv(userList:User[]):string {

    let retList:string[] = [];

    let headRowList:string[] = [];
    headRowList.push('email', 'level', 'passwordSet', 'status', 'groupIdList')

    retList.push(headRowList.join(','));

    for(let user of userList) {

      let row = [];
      row.push(this.forceString(user.email));
      row.push(this.forceString(user.level));
      row.push(this.forceString(user.passwordSet?'true':'false'));
      row.push(this.forceString(user.status));
      row.push(this.forceString(user.groupIdList.join("\n")));

      retList.push(row.join(','));
    }
    
    return retList.join("\n");
  }

  public apiKeysToCsv(apiKeys:ApiKey[]):string {

    let retList:string[] = [];

    let headRowList:string[] = [];
    headRowList.push('apiKey', 'level', 'status', 'description', 'tps', 'tpd', 'groupIdList')
    retList.push(headRowList.join(','));

    for(let apiKey of apiKeys) {

      let row = [];
      row.push(this.forceString(apiKey.apiKey));
      row.push(this.forceString(apiKey.level));
      row.push(this.forceString(apiKey.status));
      row.push(this.forceString(apiKey.description ? apiKey.description : ''));
      row.push(apiKey.tps);
      row.push(apiKey.tpd);
      row.push(this.forceString(apiKey.groupIdList.join("\n")));
      
      retList.push(row.join(','));
    }
    
    return retList.join("\n");
  }

  public subListToCSV(subList:Subscription[]):string {

    let retList:string[] = [];

    let headRowList:string[] = [];
    headRowList.push('subscriptionId', 'enterpriseId', 'type', 'endpoint', 'filter', 'interval', 'deliveries', 'pending', 'cascade', 'lastDeliveryTs')

    retList.push(headRowList.join(','));

    for(let sub of subList) {

      let row = [];
      row.push(sub.subscriptionId);
      row.push(this.forceString(sub.enterpriseId));
      row.push(this.forceString(sub.type));
      row.push(this.forceString(this.subEndpointToCell(sub)));
      row.push(this.forceString(this.subFilterToCell(sub)));
      row.push(sub.pushInterval);
      row.push(sub.deliveries);
      row.push(sub.pending);
      row.push(sub.cascade ? this.forceString(`${sub.cascade}`) : 'FALSE');
      row.push(sub.lastDeliveryTs ? moment(sub.lastDeliveryTs).toISOString() : '');
      
      retList.push(row.join(','));
    }
    
    return retList.join("\n");
  }

  private subEndpointToCell(sub:Subscription):string {

    let retList:string[] = [];

    switch(sub.type) {
      case 'http':

        const httpEndpoint = sub.endpoint as HttpEndpoint
        retList.push(`url: ${httpEndpoint.url}`);

        if(httpEndpoint.headerList && httpEndpoint.headerList.length > 0)
          retList.push(...httpEndpoint.headerList.map(header => `header: ${header}`))

        break;

      case 'sns':
        const snsEndpoint = sub.endpoint as SnsEndpoint;
        retList.push(`accessKeyId: ${snsEndpoint.accessKeyId}`);
        retList.push(`secretAccessKey: ${snsEndpoint.secretAccessKey}`);
        retList.push(`region: ${snsEndpoint.region}`);
        retList.push(`topicArn: ${snsEndpoint.topicArn}`);
        break;
      
      case 'kinesis':
        const kinesisEndpoint = sub.endpoint as KinesisEndpoint;
        retList.push(`accessKeyId: ${kinesisEndpoint.accessKeyId}`);
        retList.push(`secretAccessKey: ${kinesisEndpoint.secretAccessKey}`);
        retList.push(`region: ${kinesisEndpoint.region}`);
        retList.push(`streamName: ${kinesisEndpoint.streamName}`);
        break;
      
      case 'ubidots':
        const ubidotsEndpoint = sub.endpoint as UbidotsEndpoint;
        retList.push(`token: ${ubidotsEndpoint.token}`);
        retList.push(`ingestDomain: ${ubidotsEndpoint.ingestDomain}`);
        break;
      
      case 'iotCore':
        const iotCoreEndpoint = sub.endpoint as IotCoreEndpoint;
        retList.push(`endpointUrl: ${iotCoreEndpoint.endpointUrl}`);
        retList.push(`accessKeyId: ${iotCoreEndpoint.accessKeyId}`);
        retList.push(`secretAccessKey: ${iotCoreEndpoint.secretAccessKey}`);
        retList.push(`region: ${iotCoreEndpoint.region}`);
        retList.push(`topicPrefix: ${iotCoreEndpoint.topicPrefix}`);
        retList.push(`topicSuffix: ${iotCoreEndpoint.topicSuffix}`);
        break;

      case 'azureEventHub':
        const azureEventHubEndpoint = sub.endpoint as AzureEventHubEndpoint;
        retList.push(`connectionString: ${azureEventHubEndpoint.connectionString}`);
        retList.push(`eventHubName: ${azureEventHubEndpoint.eventHubName}`);
        break;

      default:
        // this shouldn't happen
    }

    return retList.join("\n");

  }

  private subFilterToCell(sub:Subscription):string {

    let retList:string[] = [];

    if(sub.groupIdList && sub.groupIdList.length > 0)
      retList.push(...sub.groupIdList.map(groupId => `groupId: ${groupId}`));
    
    if(sub.deviceType)
      retList.push(`deviceType: ${sub.deviceType}`);

    return retList.join("\n");

  }
}